/* eslint-disable @typescript-eslint/no-explicit-any */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment, Ref, useState } from "react";
import Icon from "@material-ui/core/Icon";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import useBooleanState from "../../../../hooks/utils/useBooleanState";

import IconPickerModal from "../../../molecules/modals/IconPickerModal";
import { IconName } from "../../../../globalTypes";
import { textFieldCss } from "../commonStyles";
import InputComponent from "../InputComponent";

const FlowioIconInput: FC<Props> = ({
  label,
  value,
  disabled = false,
  defaultValue,
  inputRef,
  onChange,
  className,
  required,
  name,
}) => {
  const [isOpen, toggleOpen] = useBooleanState(false);
  const [selectedIcon, setIcon] = useState(defaultValue || value);

  const selectIcon = (newIcon: IconName) => {
    if (onChange) {
      onChange(newIcon);
    }
    setIcon(newIcon);
    toggleOpen();
  };

  return (
    <Fragment>
      <TextField
        label={label}
        variant="outlined"
        value={value || selectedIcon}
        onClick={toggleOpen}
        css={textFieldCss()}
        InputProps={{
          inputComponent: InputComponent,
          endAdornment: (
            <InputAdornment position="end">
              <Icon>{selectedIcon}</Icon>
            </InputAdornment>
          ),
          disabled,
          inputRef,
          name,
          required,
          inputProps: { "data-cy": "input flowio-icon-input" },
        }}
      />
      <IconPickerModal
        isOpen={isOpen}
        toggleModal={toggleOpen}
        callbackFnc={selectIcon}
      />
    </Fragment>
  );
};

type Props = (
  | ControlledOnlyProps
  | UncontrolledOnlyProps
  | RefControlledOnlyProps
) & {
  label?: string;
  inputRef?: Ref<any>;
  disabled?: boolean;
  onChange?: (value: IconName) => void;
  className?: string;
  name?: string;
  required?: boolean;
};

type ControlledOnlyProps = {
  value: string | number;
  defaultValue?: undefined;
  inputRef?: undefined;
};
type UncontrolledOnlyProps = {
  value?: undefined;
  defaultValue: string | number;
  inputRef: Ref<any>;
};
type RefControlledOnlyProps = {
  value?: undefined;
  defaultValue?: undefined;
  inputRef: Ref<any>;
};

export default FlowioIconInput;
export type FlowioIconInputProps = Props;
